module.exports = __webpack_public_path__ + "img/blog.051cb91a.svg";